import './ToggleSearchButton.scss';

interface IToggleSearchButton {
  onToggle: () => void;
  value: boolean;
  disabled?: boolean;
}

const ToggleSearchButton = (props: IToggleSearchButton) => {
  const { onToggle, value = false, disabled = false } = props;
  return (
    <div className="toggle-search-button">
      <label className="switch" aria-label="Toggle Search">
        <input
          onChange={onToggle}
          type="checkbox"
          role="button"
          checked={value}
          data-testid="toggle-search-button"
          disabled={disabled}
        />
        <span className="slider round"></span>
      </label>
    </div>
  );
};

export default ToggleSearchButton;
